function getFinalType(scope, type) {
  return scope ? `${scope.name}.${type}` : type;
}

export function createAction(type, payloadMapper, metaMapper) {
  const finalType = getFinalType(this, type);

  function actionCreator(...args) {
    const action = {
      type: finalType,
      payload: payloadMapper ? payloadMapper(...args) : args[0],
    };

    if (action.payload instanceof Error) {
      action.error = true;
    }

    if (metaMapper) {
      action.meta = metaMapper(...args);
    }

    return action;
  }

  actionCreator.toString = () => finalType;
  actionCreator.displayName = finalType;

  return actionCreator;
}

function createReqAction(type) {
  const finalType = getFinalType(this, type);

  return {
    start: createAction(`${finalType}.start`),
    done: createAction(`${finalType}.done`),
    error: createAction(`${finalType}.error`),
  };
}

function setupApi(createActionFn, scope) {
  // eslint-disable-next-line
  createActionFn.request = createReqAction.bind(scope);
}

setupApi(createAction);

export function scopedCreator(scopeName) {
  const scope = { name: scopeName };
  const scopedCreateAction = createAction.bind(scope);

  setupApi(scopedCreateAction, scope);

  return scopedCreateAction;
}

export default createAction;
